import { render, staticRenderFns } from "./ResultadoSt.vue?vue&type=template&id=cb381dbe&scoped=true&"
import script from "./ResultadoSt.vue?vue&type=script&lang=js&"
export * from "./ResultadoSt.vue?vue&type=script&lang=js&"
import style0 from "./ResultadoSt.vue?vue&type=style&index=0&id=cb381dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb381dbe",
  null
  
)

export default component.exports